import { render, staticRenderFns } from "./antecedent-allergologie-environnement.html?vue&type=template&id=8c70a306&scoped=true&external"
import script from "./antecedent-allergologie-environnement.js?vue&type=script&lang=js&external"
export * from "./antecedent-allergologie-environnement.js?vue&type=script&lang=js&external"
import style0 from "./antecedent-allergologie-environnement.scss?vue&type=style&index=0&id=8c70a306&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c70a306",
  null
  
)

export default component.exports